import React from 'react';
import classes from'./Loader.css';
const loader = () => {
    return <div className={classes.loader}>Loading...</div>;
}

export default loader;


// WEBPACK FOOTER //
// ./src/components/UI/Loader/Loader.js